var map = {
	"./007-microphone-1.png": 58703,
	"./010-home.png": 67952,
	"./013-document-1.png": 41345,
	"./014-document.png": 3534,
	"./015-color-palette.png": 35943,
	"./017-video-camera.png": 43291,
	"./Interview-logo.png": 86794,
	"./Learning-logo-black-1400X320.png": 52194,
	"./Learning-logo-white-1400X320.png": 5560,
	"./Prashnamanch-acadeic-logo.png": 5806,
	"./Prashnamanch-fs-logo.png": 42319,
	"./arrow-left.png": 34666,
	"./arrow-right.png": 52231,
	"./bell.svg": 41478,
	"./dev_focus.svg": 65835,
	"./envelope.svg": 24805,
	"./google-plus.svg": 82421,
	"./home.svg": 31768,
	"./learning-black.png": 43901,
	"./learning-white.png": 81991,
	"./left-bar.svg": 14302,
	"./logo-white (1).png": 68958,
	"./message.svg": 37022,
	"./pm-academic-logo-text-new.png": 43303,
	"./pm-fs-logo-text-new.png": 45391,
	"./prashnamanch-logo-text.png": 85935,
	"./prashnmanch-logo.jpg": 6182,
	"./setting.svg": 75467,
	"./tesseract-assessment-logo.png": 48202,
	"./tesseract-learning-logo.png": 25298,
	"./tesseractLogoAndText.png": 55338
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66609;